import MediaApi from '@packages/media/api';

export class MediaMarketingApi extends MediaApi {
    static resource = 'media/marketing';
}

export default MediaMarketingApi;
